import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { settings } from 'app/core/settings';
import { PrefixUrlHostedArray } from 'app/core/shared/enum/prefix-url-hosted-enum';
import { PrefixApiPortalEnum } from 'app/core/shared/enum/prefix-api-portal-enum';
var ChangeRegionComponent = /** @class */ (function () {
    function ChangeRegionComponent(dialogService) {
        this.dialogService = dialogService;
        this.prefixUrlHosted = PrefixUrlHostedArray;
        this.prefixApiPortalEnum = PrefixApiPortalEnum;
    }
    ChangeRegionComponent.prototype.showLinkUrlHosted = function (value) {
        return !(value === this.prefixUrlHostedSettings);
    };
    Object.defineProperty(ChangeRegionComponent.prototype, "urlHosted", {
        get: function () {
            var _this = this;
            var hostedName = this.prefixUrlHosted.find(function (value) {
                return value.key === _this.prefixUrlHostedSettings;
            });
            return hostedName.value || 'Undefined';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangeRegionComponent.prototype, "prefixUrlHostedSettings", {
        get: function () {
            return this.settings.сloudSite.name.split('.')[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangeRegionComponent.prototype, "settings", {
        get: function () {
            return settings;
        },
        enumerable: true,
        configurable: true
    });
    ChangeRegionComponent.prototype.closeDialog = function () {
        this.dialogService.close();
    };
    return ChangeRegionComponent;
}());
export { ChangeRegionComponent };
